module.exports = __webpack_public_path__ + "static/media/ionic.84938842.png";